/**
 * Builds a formatted URL with query parameters.
 * @param origin - The origin of the URL.
 * @param url - The path of the URL.
 * @param params - The query parameters object.
 * @returns The formatted URL.
 */
function buildUrl(origin: string, url: string, params?: string | string[][] | Record<string, string> | URLSearchParams): string {
  const queryParams = new URLSearchParams(params);
  return `${origin}${url}&${queryParams.toString()}`;
}

export default buildUrl;
